import { Block, inlinesToText } from './markdownBlocks';

/** Plain text: one block per paragraph, lists prefixed, tables tab-separated. */
export function blocksToText(blocks: Block[]): string {
  const out: string[] = [];
  for (const block of blocks) {
    switch (block.kind) {
      case 'heading':
        out.push(block.text, '');
        break;
      case 'paragraph':
        out.push(inlinesToText(block.inlines), '');
        break;
      case 'list':
        block.items.forEach((item, i) =>
          out.push(`${block.ordered ? `${i + 1}.` : '-'} ${inlinesToText(item)}`)
        );
        out.push('');
        break;
      case 'table':
        out.push(block.header.join('\t'));
        for (const row of block.rows) out.push(row.join('\t'));
        out.push('');
        break;
      case 'imageSuggestion':
        out.push(`[Image suggestion: ${block.text}]`, '');
        break;
      case 'quote':
        out.push(`> ${block.text}`, '');
        break;
    }
  }
  return out.join('\n');
}
